const title = `TRIZ for Computer Science Program Optimization`;
const date = `October 2021`;
export const trizPost = {
  title: title,
  date: date,
  url: 'posts/TRIZ',
  body: `# ${title}

<sub>${date}</sub>

<span class="post-first-character">I</span>

would like to introduce a rough concept called TRIZ for Computer Science (CS). TRIZ is an inspiring approach to creative problem solving that can be utilized in the field of computer science. The goal of this concept is to spur ideas when facing performance problems and optimization needs in computer science.

[TRIZ](https://en.wikipedia.org/wiki/TRIZ), or "theory of inventive problem solving," was developed by Genrich Altshuller, a Soviet inventor and science-fiction author, beginning in 1946 [1]. The theory is based on extensive research that covers hundreds of thousands of inventions across various fields. TRIZ defines generalizable patterns in the nature of inventive solutions and the distinguishing characteristics of the problems that these inventions have overcome. This includes patterns of invention found in the global patent literature.

TRIZ for CS covers topics such as algorithms, data structures, time-space trade-off, parallelism, fidelity, equivalence, patterns, overhead, hardware, and constraints. This approach is useful when faced with unsolved research challenges. TRIZ for CS aspires to be like the original [TRIZ summary chart](https://en.wikipedia.org/wiki/TRIZ#/media/File:40_principles_of_TRIZ_method_720dpi.jpg). Other related work includes the [Map of Computer Science](https://iibawards-prod.s3.amazonaws.com/projects/images/000/002/333/large.png?1505504208), [Computer Science Subway Map](https://pbs.twimg.com/media/EICA0Q-XkAALXMF.jpg:large), and [Computer Science Mind Map](https://i.redd.it/13v6seyveh661.png). However, none of these works focus on optimizing software performance.

While this concept is still in its early stages, it holds potential for improving problem-solving approaches in the field of computer science. There may be missing parts, and an improved organization could be developed using color. However, the basis of TRIZ for CS offers an exciting avenue for generating new ideas and solutions to complex problems. Overall, TRIZ for CS is a valuable tool that can be utilized in the world of computer science to optimize performance and overcome difficult challenges.
<span class="post-trailing-square">■</span>

<span>
  <a target="_blank" href="../images/TRIZ.pdf">TRIZ.pdf</a>
  |
  <a target="_blank" href="../images/TRIZ.pptx">TRIZ.pptx</a>
  |
  <a target="_blank" href="../images/TRIZ.jpg">TRIZ.jpg</a>
</span>

<br>
<br>

<img src="../images/TRIZ.jpg" width="100%">

`};